import { Controller } from '@hotwired/stimulus';
import { callApiWithoutBody } from '../common/AjaxUtil';

export default class BoardSelector extends Controller {
  static values = {
    boardId: Number,
    boardType: String,
  };

  static targets = ['select', 'option'];

  static optionTemplate = `<option value="{{boardId}}" data-board-selector-target="option">{{boardName}}</option>`;

  connect() {
    const boardType = this.boardTypeValue;
    const url = `/api/boards?boardType=${boardType}&isManaged=true`;
    callApiWithoutBody(url, 'GET').then((boards) => {
      let options = '';
      boards
        .filter((board) => board.id !== this.boardIdValue)
        .forEach((board) => {
          options += BoardSelector.optionTemplate.replace('{{boardName}}', board.name).replace('{{boardId}}', board.id);
        });
      this.element.insertAdjacentHTML('beforeend', options);
    });
  }
}
